import * as Yup from 'yup';
import { m } from 'framer-motion';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import LoadingButton from '@mui/lab/LoadingButton';

import { contactApi } from 'src/api/commonapi';

import { useSnackbar } from 'src/components/snackbar';
import { varFade, MotionViewport } from 'src/components/animate';
import FormProvider, { RHFTextField } from 'src/components/hook-form';

// ----------------------------------------------------------------------

export default function FaqsForm() {
  const { enqueueSnackbar } = useSnackbar();

  const ContactSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    email: Yup.string().required('Email is required').email('Email must be a valid email address'),
    subject: Yup.string().required('Subject is required'),
    message: Yup.string().required('Message is required'),
  });
  const defaultValues = {
    name: '',
    email: '',
    subject: '',
    message: '',
  };
  const methods = useForm({
    resolver: yupResolver(ContactSchema),
    defaultValues,
  });

  const {
    reset,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = handleSubmit(async (data) => {
    try {
      const response = await contactApi.sendContactMessage(data);
      if (response && response.message) {
        enqueueSnackbar(response.message, { variant: 'success' });
        reset();
      } else if (response && response.error) {
        enqueueSnackbar(response.error, { variant: 'error' });
      }
    } catch (error) {
      console.error(error);
      reset();
      enqueueSnackbar('An unexpected error occurred.', { variant: 'error' });
    }
  });
  return (
    <FormProvider methods={methods} onSubmit={onSubmit}>
      <Stack component={MotionViewport} spacing={3}>
        <m.div variants={varFade().inUp}>
          <Typography variant="h4">{`Haven't found the right help?`}</Typography>
        </m.div>

        <m.div variants={varFade().inUp}>
          <RHFTextField name="name" label="Name" />
        </m.div>

        <m.div variants={varFade().inUp}>
          <RHFTextField name="email" label="Email address" />
        </m.div>

        <m.div variants={varFade().inUp}>
          <RHFTextField name="subject" label="subject" />
        </m.div>

        <m.div variants={varFade().inUp}>
          <RHFTextField
            fullWidth
            name="message"
            label="Enter your message here."
            multiline
            rows={4}
          />
        </m.div>

        <m.div variants={varFade().inUp}>
          <LoadingButton
            color="inherit"
            size="large"
            type="submit"
            variant="contained"
            loading={isSubmitting}
          >
            Send Message
          </LoadingButton>
        </m.div>
      </Stack>
    </FormProvider>
  );
}
